
(function() {
    'use strict';

    var markViewed = function($timeout, ajaxCall) {
        return {
            restrict: "EA",
            replace: true,
            transclude: false,
            scope: true,
            bindToController: {
                viewed: "@",
                ajaxContentUrl: "@" // we want to expose loading, so we can disable button while the results are being loaded
            },
            controllerAs: "ctrl",
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                $timeout(function(){
                    _this.viewed = (_this.viewed == "true") ? true : false;
                });

                _this.markViewed = function(e){
                    if(!_this.viewed) {
                        _this.viewed = true;
                        ajaxCall.getData(_this.ajaxContentUrl).then(
                            function(response){ },
                            function(response){ }
                        );
                    }
                }

            }],
            template: [
                '<a href="javascript:void(0);" class="marked-viewed glyphicon" ng-class="{\'glyphicon-eye-open\': !ctrl.viewed, \'glyphicon-eye-close\': ctrl.viewed }"',
                    ' ng-click="ctrl.markViewed();" title="Mark As Viewed" role="checkbox" aria-checked="{{ctrl.viewed}}">',
                '</a>'].join('')

        };
    }
    markViewed.$inject = ['$timeout', 'ajaxCall'];
    angular.module('app').directive('markViewed', markViewed);

}());
